export const environment = {
    production: true,
    apiUrl: 'https://meetplusgreet.sit-co.ru/api'
};
